(function (root, factory) {
  'use strict';
  var handoff = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = handoff;
  else if (root) root.WTXFirstOrderHandoff = handoff;
}(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';
  var records = new WeakMap();
  var notesId = 'custom#anything_else_christopher_should_know';

  function formRoot() {
    if (!root || !root.document) return null;
    var host = root.document.querySelector('shopify-forms-embed#app-embed');
    var shadow = host && host.shadowRoot;
    return shadow && shadow.querySelector('form') ? shadow : null;
  }

  function writable(field) {
    return field && !field.disabled && !field.readOnly &&
      (field.tagName === 'TEXTAREA' || field.tagName === 'INPUT' && field.type === 'text');
  }

  function write(field, value) {
    if (!writable(field) || typeof value !== 'string') return false;
    if (Number.isInteger(field.maxLength) && field.maxLength >= 0 && value.length > field.maxLength) return false;
    var Constructor = field.tagName === 'TEXTAREA' ? root.HTMLTextAreaElement : root.HTMLInputElement;
    var descriptor = Constructor && Object.getOwnPropertyDescriptor(Constructor.prototype, 'value');
    if (!descriptor || typeof descriptor.set !== 'function' || typeof root.Event !== 'function') return false;
    descriptor.set.call(field, value);
    field.dispatchEvent(new root.Event('input', { bubbles: true, composed: true }));
    field.dispatchEvent(new root.Event('change', { bubbles: true, composed: true }));
    return true;
  }

  function transfer(input) {
    try {
      if (!input || typeof input.notes !== 'string' || !input.notes.trim() ||
        typeof input.heading !== 'string' || !input.heading.trim() || /[\r\n]/.test(input.heading)) return { ok: false };
      if (root && root.WTXFirstOrderExperience && typeof root.WTXFirstOrderExperience.openSupport === 'function') {
        return { ok: root.WTXFirstOrderExperience.openSupport(input.notes) === true, destination: 'native-contact' };
      }
      var shadow = formRoot();
      var field = shadow && shadow.getElementById(notesId);
      if (!field || field.tagName !== 'TEXTAREA' || !writable(field)) return { ok: false };
      var existing = field.value;
      if (typeof existing !== 'string') return { ok: false };
      var block = input.heading.trim() + '\n' + input.notes.trim();
      var previous = records.get(shadow);
      var start = previous ? existing.indexOf(previous) : -1;
      if (start >= 0 && (start > 0 && existing.slice(start - 2, start) !== '\n\n' ||
        start + previous.length < existing.length && existing.slice(start + previous.length, start + previous.length + 2) !== '\n\n')) start = -1;
      var value;
      if (start >= 0) value = existing.slice(0, start) + block + existing.slice(start + previous.length);
      else if (existing === block || existing.endsWith('\n\n' + block)) value = existing;
      else value = existing + (existing ? '\n\n' : '') + block;
      if (value !== existing && !write(field, value)) return { ok: false };
      var currentRoot = formRoot();
      var currentField = currentRoot && currentRoot.getElementById(notesId);
      if (!currentField || currentField.value !== value) return { ok: false };
      records.set(currentRoot, block);
      var optional = [
        ['names', 'custom#your_pups_name'],
        ['diet', 'custom#what_is_your_dog_eating_now'],
        ['weights', 'custom#current_weight']
      ];
      optional.forEach(function (entry) {
        var supplied = input[entry[0]];
        var targetRoot = formRoot();
        var target = targetRoot && targetRoot.getElementById(entry[1]);
        if (typeof supplied === 'string' && supplied.trim() && writable(target) &&
          typeof target.value === 'string' && !target.value.trim()) write(target, supplied.trim());
      });
      currentRoot = formRoot();
      currentField = currentRoot && currentRoot.getElementById(notesId);
      return { ok: Boolean(currentField && currentField.value === value) };
    } catch (_) {
      return { ok: false };
    }
  }

  return { transfer: transfer };
}));
